export const policyRefundMethods = [
  {
    value: 'eft_credit_card',
    label: 'POLICY_DETAILS.REFUND.methodRefundReceived.eftCreditCard',
  },
  {
    value: 'eft_debit',
    label: 'POLICY_DETAILS.REFUND.methodRefundReceived.eftDebit',
  },
  {
    value: 'direct_deposit',
    label: 'POLICY_DETAILS.REFUND.methodRefundReceived.directDeposit',
  },
];
